module.exports = __webpack_public_path__ + "img/calendar.21e468fe.svg";